export const TODASHBOARD = "/";
export const TOINVOICES = "/invoices";
export const TOBILLS = "/bills";
export const TOPAYMENTSOURCES = "/payment-sources";
export const TOVENDORMANAEMENT = "/vendors";
export const TOCLIENTS = "/clients-listing";
export const TOPERFORMANCEANALYSIS = "/performance-analysis";
export const TOWORKFLOWS = "/workflows";
export const TONOTIFICATIONS = "/notifications";
export const TOACTIVITYLOG = "/activity-log";
export const TOREPORTS = "/reports";
export const TOUSERMANAGEMENT = "/user-management";
export const TOSETTINGS = "/settings";
export const TOTRANSACTIONS = "/transactions";
export const TOVATMANAGEMENT = "/vta-management";
export const TOCATEGORIES = "/categories";
export const TOKPI = "/key-performance-indicator";
export const TOIMPORTTRANSACTIONS = "/import-transactions";
export const TOSUBSCRIPTIONINVOICES = "/subscription-invoices";
